const uploadImageOptions = {
    name: 'photo',
    multiple: false,
    accept: '.jpg, .jpeg, .png, .webp',
};
export default uploadImageOptions;
